export const MODERATE = "MODERATE";
export const COASTAL = "COASTAL";
export const MOUNTAIN = "MOUNTAIN";
export const DESERT = "DESERT";
export const INLAND = "INLAND";
